import React, { Component } from "react";
import dayjs from "dayjs";
import { MessageType } from "./Message";

class CloseMessage extends Component {

    render() {
        return (
            <div className={this.messageContainerClassName()} style={this.messageContainerStyle()}>
                <div className={this.messageBoxClassName()} style={this.messageBoxStyle()}>
                    <strong>{this.props.message.message.text}</strong>
                    <br />
                </div>
                {this.showMessageTime() && <div className={this.messageTimeClassName()} style={this.messageTimeStyle()}>{dayjs.unix(this.props.message.message.sentTimestamp).format("h:mm a")}</div>}
            </div>
        )
    }

    showMessageTime = () => {
        return (this.props.message.type !== MessageType.info);
    }

    messageTimeClassName = () => {
        switch (this.props.message.type) {
            case MessageType.info: return "s360-message-time-info";
            default: return "";
        }
    }

    messageBoxClassName = () => {
        switch (this.props.message.type) {
            case MessageType.info: return "s360-message-box-info";
            default: return "";
        }
    }

    messageContainerClassName = () => {
        switch (this.props.message.type) {
            case MessageType.info: return "s360-message-cotainer-info";
            default: return "";
        }
    }

    messageBoxStyle = () => {
        let config = this.props.config;
        switch (this.props.message.type) {
            case MessageType.info: return { paddingTop:"10px", fontFamily: config.designDetails.messageFont, fontSize: config.designDetails.messageTimeFontSize, color: config.designDetails.messageFontColor }
            default: return {}
        }
    }

    messageContainerStyle = () => {
        // let config = this.props.config
        return {}
    }

    messageTimeStyle = () => {
        let config = this.props.config;
        // let fontSize = config.designDetails.messageFontSize - (config.designDetails.messageFontSize / 4);
        switch (this.props.message.type) {
            case MessageType.info:     return { fontFamily: config.designDetails.messageFont, fontSize: config.designDetails.messageTimeFontSize, color: config.designDetails.messageFontColor }
            default: return {}
        }
    }

}

export default CloseMessage;
